// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-module--layout--2fgcF","body":"layout-module--body--3v6_B","figure":"layout-module--figure--25FwR","logo":"layout-module--logo--2kT79"};